export const SPECIES_WEAPON_MODES = [
    { value: "AllBrawl", label: "Stack on all Brawl attacks" },
    { value: "Secondary", label: "Separate weapon" },
];

const speciesWeaponMode = (speciesWeapon) => {
    if (!speciesWeapon) { return null; }
    if (speciesWeapon.Mode === "Secondary" || speciesWeapon.Secondary) { return "Secondary"; }
    return "AllBrawl";
};

export default speciesWeaponMode;
